import TimeField from "../components/TimeField.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/DatePicker/DateRangePicker/DateRangeTimeFields.tsx
const DateRangeTimeFields = ({ groupProps, size, readonly, startDateLabel, endDateLabel, startTimeValue, endTimeValue, onChangeStart, onChangeEnd }) => {
	return /* @__PURE__ */ jsxs("div", {
		...groupProps,
		className: "group flex w-full flex-col gap-2",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex w-full items-center gap-2",
			children: [/* @__PURE__ */ jsx("span", {
				className: "text-neutrals-40 min-w-[4.5rem] text-sm",
				children: startDateLabel
			}), /* @__PURE__ */ jsx("div", {
				className: "border-neutrals-80 bg-neutrals-95 flex-1 rounded-xl border-2 px-3 py-1.5 data-[size='lg']:py-2 data-[size='md']:py-1.5 data-[size='sm']:py-1",
				"data-size": size,
				children: /* @__PURE__ */ jsx(TimeField, {
					size,
					isDisabled: readonly,
					value: startTimeValue,
					onChange: onChangeStart
				})
			})]
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex w-full items-center gap-2",
			children: [/* @__PURE__ */ jsx("span", {
				className: "text-neutrals-40 min-w-[4.5rem] text-sm",
				children: endDateLabel
			}), /* @__PURE__ */ jsx("div", {
				className: "border-neutrals-80 bg-neutrals-95 flex-1 rounded-xl border-2 px-3 py-1.5 data-[size='lg']:py-2 data-[size='md']:py-1.5 data-[size='sm']:py-1",
				"data-size": size,
				children: /* @__PURE__ */ jsx(TimeField, {
					size,
					isDisabled: readonly,
					value: endTimeValue,
					onChange: onChangeEnd
				})
			})]
		})]
	});
};
//#endregion
export { DateRangeTimeFields as default };

//# sourceMappingURL=DateRangeTimeFields.js.map